import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { RefreshCw, ScrollText } from "lucide-react";

export default function LogsTab({ logs, reload }) {
  const fmt = (iso) => {
    try {
      return new Date(iso).toLocaleString("it-IT", {
        day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit",
      });
    } catch {
      return iso;
    }
  };

  return (
    <div className="rounded-xl border border-slate-200 bg-white overflow-hidden shadow-sm">
      <div className="flex items-center justify-between p-4 border-b border-slate-200">
        <div>
          <h3 className="font-heading text-lg text-slate-900 flex items-center gap-2">
            <ScrollText className="h-5 w-5 text-brand-orange" /> Log accessi
          </h3>
          <p className="text-sm text-slate-500">Ultimi {logs.length} accessi alle app</p>
        </div>
        <Button variant="outline" onClick={reload} data-testid="refresh-logs-btn">
          <RefreshCw className="h-4 w-4 mr-2" /> Aggiorna
        </Button>
      </div>
      <div className="overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Data e ora</TableHead>
              <TableHead>Utente</TableHead>
              <TableHead>App</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {logs.length === 0 ? (
              <TableRow>
                <TableCell colSpan={3} className="text-center text-slate-400 py-10">Nessun accesso registrato.</TableCell>
              </TableRow>
            ) : (
              logs.map((l) => (
                <TableRow key={l.log_id} data-testid={`log-row-${l.log_id}`}>
                  <TableCell className="text-slate-600 text-sm whitespace-nowrap">{fmt(l.timestamp)}</TableCell>
                  <TableCell>
                    <div className="text-slate-900 text-sm">{l.user_name || l.user_email}</div>
                    <div className="text-xs text-slate-400">{l.user_email}</div>
                  </TableCell>
                  <TableCell className="text-slate-600 text-sm">{l.app_name}</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
